export const TEMP_WS_CHAT_ID = 'teste-chat-oli';
